import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Menjalankan link yang diisi admin di CMS. Admin bisa mengisi:
 *  - path internal   : "/Contact", "/products/seal-product", "contact"
 *  - URL eksternal   : "https://..." -> tab baru
 *  - mailto: / tel:  -> aplikasi bawaan perangkat
 */
export function useCmsLink() {
  const navigate = useNavigate();

  return useCallback(
    (link?: string | null) => {
      const target = link?.trim();

      if (!target) return;

      // "//cdn.example.com" ikut dianggap eksternal.
      if (/^(https?:)?\/\//i.test(target)) {
        window.open(target, "_blank", "noopener,noreferrer");
        return;
      }

      if (/^(mailto|tel):/i.test(target)) {
        window.location.href = target;
        return;
      }

      if (target.startsWith("#")) {
        window.location.hash = target;
        return;
      }

      // "contact" (tanpa "/") harus tetap diarahkan dari root, bukan relatif
      // terhadap halaman yang sedang dibuka.
      navigate(target.startsWith("/") ? target : `/${target}`);
    },
    [navigate]
  );
}
